import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setData } from '../../actions/index';

const styles = theme => ({
  root: {
    padding: 20,
    '& h2': {
      marginTop: 0,
    },
  },
  avatar: {
    border: '2px solid transparent',
    borderRadius: '5px',
    display: 'inline-block',
    cursor: 'pointer',
    width: isMobileApp
      ? 64
      : 72,
    height: isMobileApp
      ? 64
      : 72,
    '&:hover': {
      border: '2px solid #0a72c7',
    },
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  avatarSelected: {
    border: '2px solid #0a72c7',
  },
  avatarsWrapper: {
    marginBottom: 20,
  },
  saveButton: {
    marginRight: 10,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
    pupils: state.pupils,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

class AvatarsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      isSubmitting: false,
      data: [],
      meta: {},
      selectedAvatar: null,
      selectedAvatarDefault: null,
      isSelectedAvatarChanged: false,
    };

    this.axiosCancel = null;

    this.reloadData = this.reloadData.bind(this);
    this.onAvatarClick = this.onAvatarClick.bind(this);
    this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
    this.onCancelButtonClick = this.onCancelButtonClick.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    axios
      .post(
        `${window.apiUrl}/avatars`,
        qs.stringify({
          pupil_id: selectedPupil.id,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          const {
            data,
            meta,
          } = response.data;

          this.setState({
            data,
            meta,
            selectedAvatar: meta.selected_avatar,
            selectedAvatarDefault: meta.selected_avatar,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  onAvatarClick(entry) {
    this.setState({
      selectedAvatar: entry.key,
      isSelectedAvatarChanged: true,
    });
  }

  onSaveButtonClick() {
    const {
      t,
      enqueueSnackbar,
      selectedPupil,
      pupils,
    } = this.props;
    const {
      selectedAvatar,
    } = this.state;

    this.setState({
      isSubmitting: true,
    });

    axios
      .post(
        `${window.apiUrl}/setavatar`,
        qs.stringify({
          pupil_id: selectedPupil.id,
          avatar: selectedAvatar,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 3000,
          });
        } else {
          enqueueSnackbar(t('You have successfully saved the avatar.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          if (appType === 'student') {
            const newSelectedPupil = {
              ...selectedPupil,
              ...{
                avatar_url: response.data.data.avatar_url,
              }
            };
            this.props.setData(newSelectedPupil, 'selectedPupil');
          } else {
            let newPupils = pupils;
            for (let i = 0; i < newPupils.length; i++) {
              if (newPupils[i].id === response.data.data.pupil_id) {
                newPupils[i].avatar_url = response.data.data.avatar_url;
                break;
              }
            }
            this.props.setData(newPupils, 'pupils');
          }
        }

        this.setState({
          isSubmitting: false,
          isSelectedAvatarChanged: false,
        });
      })
      .catch((thrown) => {});
  }

  onCancelButtonClick() {
    const {
      selectedAvatarDefault,
    } = this.props;

    this.setState({
      selectedAvatar: selectedAvatarDefault,
      isSelectedAvatarChanged: false,
    });
  }

  render() {
    const {
      classes,
      t,
    } = this.props;
    const {
      isLoading,
      isLoaded,
      isSubmitting,
      data,
      selectedAvatar,
      isSelectedAvatarChanged,
    } = this.state;

    return (
      <Paper className={`avatars-page ${classes.root}`}>
        <h2>{t('Choose avatar')}</h2>
        {isLoading && !isLoaded && (
          <div className={classes.textCenter}>
            <CircularProgress />
          </div>
        )}
        {isLoaded && data.length === 0 && (
          <p>{t('No avatars found')}</p>
        )}
        {isLoaded && data.length > 0 && (
          <>
            <div className={classes.avatarsWrapper}>
              {data.map((entry) => {
                return (
                  <div
                    className={entry.key === selectedAvatar
                      ? `${classes.avatar} ${classes.avatarSelected}`
                      : classes.avatar}
                    key={entry.key}
                    onClick={this.onAvatarClick.bind(this, entry)}
                  >
                    <img src={entry.url} />
                  </div>
                );
              })}
            </div>
            <div>
              <Button
                onClick={this.onSaveButtonClick}
                color="primary"
                variant="contained"
                disabled={!isSelectedAvatarChanged || isSubmitting}
                className={`save-button ${classes.saveButton}`}
              >
                {isSubmitting && (
                  <>
                    <CircularProgress size={14} />
                    <span> {t('Saving ...')}</span>
                  </>
                )}
                {!isSubmitting && t('Save')}
              </Button>
              <Button
                onClick={this.onCancelButtonClick}
                color="default"
                variant="contained"
                disabled={!isSelectedAvatarChanged || isSubmitting}
                className="cancel-button"
              >
                {t('Cancel')}
              </Button>
            </div>
          </>
        )}
      </Paper>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(AvatarsPage)))
);
